import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs/internal/observable/of';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { switchMap } from 'rxjs/internal/operators/switchMap';

import { ProductsService } from '../services';
import { ProductsActions } from './products.actions';

@Injectable()
export class ProductsEffects {
  private readonly productsService = inject(ProductsService);
  private readonly actions$ = inject(Actions);

  getProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductsActions.loadProducts),
      switchMap(({ queryParams }) => this.productsService.loadProducts(queryParams)),
      map(({ products, total }) => ProductsActions.loadProductsSuccess({ products, total })),
      catchError((error: string) => of(ProductsActions.productsFailure({ error }))),
    );
  });

  loadMoreProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductsActions.loadMoreProducts),
      switchMap(({ queryParams }) => {
        return this.productsService.loadProducts(queryParams);
      }),
      map(({ products, total }) => ProductsActions.loadMoreProductsSuccess({ products, total })),
      catchError((error: string) => of(ProductsActions.productsFailure({ error }))),
    );
  });

  loadProduct$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductsActions.loadProduct),
      switchMap(({ id }) => this.productsService.getProduct(id)),
      map(product => ProductsActions.loadProductSuccess({ product })),
      catchError((error: string) => of(ProductsActions.productsFailure({ error }))),
    );
  });

  loadSizes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductsActions.loadSizes),
      switchMap(() => this.productsService.loadSizes()),
      map(sizes => ProductsActions.loadSizesSuccess({ sizes })),
      catchError((error: string) => of(ProductsActions.productsFailure({ error }))),
    );
  });
}
